import { render, staticRenderFns } from "./ClassEdit.vue?vue&type=template&id=063a1384&"
import script from "./ClassEdit.vue?vue&type=script&lang=js&"
export * from "./ClassEdit.vue?vue&type=script&lang=js&"
import style0 from "./ClassEdit.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports